/**
 * Module for the general theme functionality.
 */



// Module imports
import * as SmoothScroll from 'smoothscroll-for-websites';
import * as viewportUnitsBuggyfill from 'viewport-units-buggyfill';




/**
 * Class for general theme functionality.
 *
 * @class      Theming (name)
 */
export class Theming
{
	/**
	 * Adds the necessary event listeners.
	 */
	static addListeners()
	{
		// Assign $ to jQuery
		let $ = jQuery;

		// No touching until DOM is ready
		$( document ).on(
			'ready',
			() =>
			{
				// Setup our scrolling modifiers as Safari is garbage as usual (I mean it's basically the new Internet Explorer)
				Theming.setupScrolling();

				// Run the buggyfill (clever name!) for viewport units (this ISN'T a polyfill, we don't care all that much about browsers that don't support this, but it DOES fix mobile Safari's random idea of making `1vh = 1 document height` or whatever it's trying to do)
				viewportUnitsBuggyfill.init();
			}
		);
	}



	/**
	 * Sets up our scrolling preferences.
	 */
	static setupScrolling()
	{
		// Is it a terrible browser?
		if
		(
			(
				'safari' === document.body.getAttribute( 'data-browser-slug' )
				&&
				'macos' !== document.body.getAttribute( 'data-os-slug' )
			)
			||
			'internet-explorer' === document.body.getAttribute( 'data-browser-slug' )
		)
		{
		}
		// Is it anything BUT those?
		else
		{
			// Disable SmoothScroll as it makes Parallax lag like shit in Chrome
			SmoothScroll.destroy();
		}
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite-child/assets/js/theming/theming.js